// Extend the Window interface to include our custom property
declare global {
  interface Window {
    __googleTranslateFixApplied?: boolean;
  }
}

// fixes issue of google translate in Chrome arbitrarily removing DOM elements in react, causing PG to crash https://issues.chromium.org/issues/41407169#comment70
export default function googleTranslateFix() {
  if (typeof window !== 'undefined' && !window.__googleTranslateFixApplied) {
    const originalRemoveChild = Node.prototype.removeChild;

    Node.prototype.removeChild = function <T extends Node>(child: T): T {
      try {
        return originalRemoveChild.call(this, child) as T;
      } catch (error) {
        if (error instanceof Error && error.name === 'NotFoundError') {
          // Prevents crashes by ignoring the error
          return child;
        }
        throw error;
      }
    };

    const originalInsertBefore = Node.prototype.insertBefore;

    Node.prototype.insertBefore = function <T extends Node>(
      newNode: T,
      referenceNode: Node | null
    ): T {
      try {
        return originalInsertBefore.call(this, newNode, referenceNode) as T;
      } catch (error) {
        if (error instanceof Error && error.name === 'NotFoundError') {
          // If insertion fails, append the element instead
          return this.appendChild(newNode) as T;
        }
        throw error;
      }
    };

    window.__googleTranslateFixApplied = true;
  }
}
